import { numberToCurrency } from '@hc-frontend/utils'

const asMoneyWithoutDecimal = numberToCurrency

function getGenericPlanBenefits<T extends HasCoreBenefits>(plan: T): PlanBenefit[] {
  const planBenefits = []

  if (!plan.coreBenefits) {
    return planBenefits
  }
  const { deductible, userCoinsurance, outOfPocketMax, lifetimeMax } = plan.coreBenefits

  if (deductible) {
    planBenefits.push({
      key: 'deductible',
      value: asMoneyWithoutDecimal(+deductible),
      title: 'Deductible'
    })
  }
  if (userCoinsurance) {
    planBenefits.push({
      key: 'coinsurance',
      value: userCoinsurance + '%',
      title: 'Coinsurance'
    })
  }

  if (outOfPocketMax) {
    planBenefits.push({
      key: 'moop',
      value: asMoneyWithoutDecimal(+outOfPocketMax),
      title: 'Max Out of Pocket'
    })
  }

  if (lifetimeMax) {
    planBenefits.push({
      key: 'coverage',
      value: asMoneyWithoutDecimal(+lifetimeMax),
      title: 'Total Policy Coverage'
    })
  }

  return planBenefits
}

export default getGenericPlanBenefits
